export default class {
  constructor() {
    this.updateDotOnSlideScroll();
    //this.handleSnapping();
  }

  updateDotOnSlideScroll() {
    const sliders = document.querySelectorAll(".js--blockCover");

    sliders.forEach((slider) => {
      const dotsWrapper = slider.querySelector(".BlockCover__dots");
      const slides = slider.querySelectorAll(".BlockCover__image");
      const mainWrapper = slider.querySelector(".BlockCover__mainImages");

      // as each slide is scrolled into view, update the dot with attribute data-active from 1 to n
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const slideNumber = entry.target.getAttribute("data-slide-number");
              dotsWrapper.setAttribute("data-active", slideNumber);
              mainWrapper.setAttribute("data-active", slideNumber);
            }
          });
        },
        { threshold: [0.5] },
      );

      slides.forEach((slide) => {
        observer.observe(slide);
      });
    });
  }

  handleSnapping() {
    const sliders = document.querySelectorAll(".js--blockCover");

    // when slider is in view set scroll-snap-type: y; to html (set timeout to 200ms). When it's out of view remove it;
    sliders.forEach((slider) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                document.documentElement.style.scrollSnapType = "y mandatory";
                console.log("enter 2x");
              }, 200);
              console.log("enter");
            } else {
              document.documentElement.style.scrollSnapType = null;
              console.log("leave");
            }
          });
        },
        { threshold: [0.2, 0.85] },
      );
      observer.observe(slider);
    });
  }
}
